import { Button, FlexBox } from '@dixa/lib-shared-habla';
import { useFormState, useWatch } from 'react-hook-form';

import { CustomFormField } from '../../../../customForms.types';
import { FormValues } from '../../types';

type Props = {
  onPreviewRequest: () => void;
};

export function ActionButtons({ onPreviewRequest }: Props): JSX.Element {
  const { isSubmitting, isDirty } = useFormState();

  const formFields = useWatch<FormValues>({
    name: 'formFields',
  }) as CustomFormField[];

  const hasFields = formFields?.length > 0;

  return (
    <FlexBox alignContent="start" gap="200">
      <Button
        variant="secondary"
        type="button"
        onClick={onPreviewRequest}
        disabled={isSubmitting || !hasFields}
      >
        Preview
      </Button>
      <Button
        isLoading={isSubmitting}
        variant="primary"
        type="submit"
        loadingIndicator="Saving..."
        disabled={!isDirty}
      >
        Save changes
      </Button>
    </FlexBox>
  );
}
